<template>
    <div id="lodLoad" class="lodLoad">
        <div class="page-content">
            <!-- 页面上方按钮区域 -->
            <div class="page-content-head">
                <el-row>
                    <el-col :span="12">
                        <button class="upload-btn" @click.prevent="lodTranslate">
                            <i class="icon iconfont iconxingzhuangbeifen3"></i> LOD转换
                        </button>
                        <button class="refresh-btn" @click.prevent="refreshFileList(false)">
                            <i class="fa fa-refresh"></i> 刷新
                        </button>
                    </el-col>
                </el-row>
            </div>
            <!-- 下方表格区域 -->
            <div class="page-table-content">
                <!-- 左侧bucket列表 -->
                <div class="bucket-list">
                    <el-collapse v-model="activeList" v-if="bucketItems.length > 0">
                        <el-collapse-item
                            v-for="(item, index) in bucketItems"
                            :title="item.name"
                            :name="item.id"
                            :key="index"
                        >
                            <ul v-if="item.children.length > 0">
                                <li
                                    v-for="(item2, index) in item.children"
                                    class="listItem"
                                    :class="{ activeItem: currentBucket === item2.name }"
                                    :key="index"
                                    @click="refreshFileList(item2.name)"
                                >
                                    {{ item2.name }}
                                </li>
                            </ul>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <!-- 文件表格 -->
                <div class="page-list">
                    <el-table
                        v-loading="isTableLoading"
                        ref="multipleTable"
                        size="mini"
                        height="95%"
                        style="width: 80%;"
                        tooltip-effect="dark"
                        fit
                        border
                        highlight-current-row
                        :data="modelsData"
                        :row-class-name="tableRowClassName"
                        :row-style="{ height: '50px', 'font-size': '14px' }"
                        :cell-style="{ padding: '0px' }"
                        :header-cell-style="{
                            'background-color': '#F5F5F5',
                            'font-size': '14px',
                            height: '50px',
                            color: '#666666',
                            'font-weight': '400',
                        }"
                        @selection-change="handleSelectionChange"
                        @sort-change="changeSort"
                    >
                        <el-table-column type="selection" width="50"></el-table-column>
                        <el-table-column
                            prop="fileName"
                            label="文件名称"
                            min-width="10%"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            prop="fileUrn"
                            label="文件urn"
                            min-width="15%"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            prop="translateTime"
                            label="转换时间"
                            sortable
                            min-width="8%"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            prop="size"
                            label="大小"
                            sortable
                            min-width="5%"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            prop="consumingTime.lod"
                            label="耗时"
                            sortable
                            min-width="5%"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            prop="modelStatus"
                            label="模型状态"
                            sortable
                            min-width="5%"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.modelStatus === '完成转换'" style="color: #22c00e;"
                                    >完成转换</span
                                >
                                <span v-else-if="scope.row.modelStatus === '排队等候'" style="color: #3d94e8;"
                                    >排队等侯</span
                                >
                                <span v-else-if="scope.row.modelStatus === '正在转换'" style="color: #ffaa3e;"
                                    >正在转换</span
                                >
                                <span v-else-if="scope.row.modelStatus === '异常退出'" style="color: #ff4929;"
                                    >异常退出</span
                                >
                                <span v-else>未转换</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" min-width="15%" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <!-- 查看 -->
                                <i
                                    class="iconfont iconliulan-moren icon view"
                                    title="查看"
                                    @click="viewmodel(scope.row)"
                                ></i>
                                <!-- 复制urn -->
                                <i
                                    class="iconfont iconcopy icon copy"
                                    title="复制urn"
                                    @click="urnDbClick(scope.row)"
                                ></i>
                                <el-dropdown class="needMore icon" @command="handleCommand">
                                    <i class="el-icon-more"></i>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item
                                            :command="beforeHandleCommand(scope.$index, scope.row, 'reConvertor')"
                                            >转换
                                        </el-dropdown-item>
                                        <el-dropdown-item
                                            v-if="scope.row.modelStatus === '完成转换'"
                                            :command="beforeHandleCommand(scope.$index, scope.row, 'shareFile')"
                                            >分享
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <el-progress
                                    v-if="scope.row.percentage > 0"
                                    type="circle"
                                    :width="30"
                                    :percentage="scope.row.percentage"
                                ></el-progress>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="paging">
                        <el-pagination
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            layout="prev, pager, next"
                            :total="totalCount"
                        ></el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!-- <modelViewsShare ref="modelViewsShare" :jobType="'obmx-lod'"></modelViewsShare> -->
        <modelViews
            ref="modelViews"
            :allJobType="allJobType"
            :objectStatus="objectStatus"
            :convertData="{ obv: null, lod: null }"
        ></modelViews>
    </div>
</template>

<script>
import DynamicLoad from 'src/common/js/dynamicLoad';
import RuntimeUtils from 'src/common/js/runtimeUtils';
import { getAllBucket, getPageObjects } from 'src/utils/modelUtils';
import { getAllJobStatus, getJobStatusForLod, JOB_STATUS, getJobType } from 'src/utils/jobUtils';
import { getUserName, setUserName } from 'src/utils/loginUtils';
import { getAppInfo } from 'src/utils/appUtils';

import { formatTime, formatConsumingTime, base64UrlEncode, analysisFileType } from 'src/utils/commonUtils';
import { getObjectViewToken } from 'src/utils/modelUtils';
import modelViews from '../components/modelViews.vue';
import modelViewsShare from 'src/pages/devCenter/consoleLab/components/modelViews-share.vue';

export default {
    name: 'lodLoad',
    components: {
        modelViews,
        modelViewsShare,
    },
    data() {
        return {
            // 默认页数
            currentPage: 1,
            // 数据总条数
            totalCount: 0,
            // 当前页面任务数
            objectNumber: 0,
            modelStatusArr: [],
            modelChangeArr: [],
            bucket_key: '',
            currentRow: {},
            modelsData: [],
            fileName: '',
            currentUrn: '',
            multipleSelection: [],
            activeList: [-1],
            bucketItems: [
                {
                    name: 'bucket列表',
                    id: -1,
                    children: [],
                },
            ],
            bucketOptions: [], // 传递给子组件的数据
            currentBucket: '',
            OBVJSStatus: false, // obvjs加载情况
            modelViewsData: [],
            tokenData: '', // 浏览用的token
            activeView: '',
            isTableLoading: false,
            allJobType: {
                obv: null,
                lod: null,
            },
            objectStatus: {
                obv: '',
                lod: '完成转换',
            },
        };
    },
    methods: {
        changeSort(val) {
            this.modelsData.sort((a, b) => a[val.prop] - b[val.prop]);
        },
        // 当前页
        handleCurrentChange(val) {
            this.currentPage = val;
            this.refreshFileList(this.$store.state.storage.bucketKey);
        },
        // LOD转换
        lodTranslate() {
            // let token = 'eyJhbGciOiJSUzI1NiJ9.eyJ1c2VyX2lkIjoiNUF3M09aejBlVmwiLCJ1c2VyX25hbWUiOiI1QXczT1p6MGVWbCIsInNjb3BlIjpbIm9idjpyZWFkIiwib2J2OndyaXRlIiwiY29sbGFiOnJlYWQiLCJjb2xsYWI6d3JpdGUiLCJib3g6cmVhZCIsImJveDp3cml0ZSJdLCJleHAiOjE2MTk2ODc2MTUwMDAsImNsaWVudF9pZCI6IkdIZWpmMng4SmN3M0V6bUIxMVd3UjVIIiwiYXV0aG9yaXRpZXMiOlsiUk9MRV9VU0VSIiwiUk9MRV9VU0VSX0FETUlOIiwiUk9MRV9BRE1JTiJdLCJqdGkiOiJqdGkifQ.i38_Cp8tgsFyYLXrDB5Qy9a6A6gw-pwvEU9hdML-wgjG8Q911YolHA3AWcbYe0EAfvKksuU3zCsAUmj3lLIqT7mRBbVLvovJ-bj0KZ4YLfceFMvTL8YNbkjXKnuU38DcY1DgMrb8OL0FBneu-V-cm9E8c0SU7WpzDlBdDr8s7XevILUPhpwT-tcvDWJP2X8u8shVZ5YSGXCK0fbQlume9aXFV6_JKIYbPiydiZ9XhNzHYGQYiLT9BvxfNMldMo7CMRM_-RErrDG_mmniC4oA4FZEy8_SJsRCw4pM1QVKi3lLeojVJS5N2Px-xfcTc01Wui_q_yDkGexrLH7bc1Nn9w'
            // if (this.multipleSelection.length) {
            //     let flg = this.multipleSelection.some(
            //         (ele) => ele.modelStatus === '排队等候' || ele.modelStatus === '正在转换',
            //     );
            //     if (flg) this.$message.error('选择对象包含排队等侯或正在转换的文件');
            //     else {
            //         this.$message('开始转换');
            //         this.multipleSelection.forEach((ele) =>
            //             postJobConvertorForLod(this.$store.state.storage.bucketKey, ele.fileName)
            //                 .then((res) => {
            //                     this.refreshFileListForLodBatch(this.$store.state.storage.bucketKey, true);
            //                 })
            //                 .catch((err) => {
            //                     this.$message.error(err.message);
            //                 }),
            //         );
            //     }
            // } else this.$message.error('请选中要转换的项目');
            this.$message.error('LOD转换功能已更新升级，请至【文件管理】页面转换！');
        },
        urnDbClick(row) {
            this.$copyText(`${row.fileUrn}`).then(
                (res) => {
                    this.$message.success('复制成功');
                },
                (err) => {
                    this.$message.error('复制失败');
                },
            );
        },
        handleRow(row) {},
        beforeHandleCommand(index, row, command) {
            return {
                index: index,
                row: row,
                command: command,
            };
        },
        handleCommand(command) {
            if (command.row.modelStatus === '排队等候') {
                this.$message.error('文件排队等候中');
            } else if (command.row.modelStatus === '正在转换') {
                this.$message.error('文件转换中');
            } else {
                switch (command.command) {
                    case 'reConvertor':
                        this.reConvertor(command);
                        break;
                    case 'shareFile':
                        this.currentRow = command.row;
                        this.shareFile();
                        break;
                }
            }
        },
        reConvertor() {
            // postJobConvertorForLod(this.$store.state.storage.bucketKey, command.row.fileName)
            //     .then((res) => {
            //         this.$message('开始转换');
            //         this.currentRow = command.row;
            //         this.refreshFileListForLodBatch(this.$store.state.storage.bucketKey, false);
            //     })
            //     .catch((err) => {
            //         if (err.responseJSON.message) {
            //             let errMessage = JSON.parse(err.responseJSON.message).message;
            //             this.$message.error(errMessage);
            //         }
            //     });
            this.$message.error('LOD转换功能已更新升级，请至【文件管理】页面转换！');
        },
        shareFile() {
            this.$message.error('LOD转换功能已更新升级，请至【文件管理】页面分享！');
            // const tempBucketKey = this.$store.state.storage.bucketKey;
            // this.fileName = this.currentRow.fileName;
            // this.currentUrn = `urn:bimbox.object:${tempBucketKey}/${this.currentRow.fileName}`;
            // Object.assign(this.currentRow, { type: 4 });
            // this.$refs.modelViewsShare.Open(
            //     {
            //         fileName: this.fileName,
            //         urn: this.currentUrn,
            //     },
            //     this.currentRow,
            // );
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 !== 0) {
                return 'even-row';
            }
            return 'odd-row';
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        setActiveItem() {
            if (this.multipleSelection.length) {
                sessionStorage.setItem('activeLod', JSON.stringify(this.multipleSelection));
            }
            if (this.currentRow && this.currentRow.fileUrn) {
                sessionStorage.setItem('activeLodRow', JSON.stringify(this.currentRow));
            }
        },
        // 刷新页面
        refreshFileList(bucketKey) {
            // 刷新的时候存在session里，销毁的时候清除这个session
            this.setActiveItem();
            let tempBucketKey = '';
            if (bucketKey) {
                tempBucketKey = bucketKey;
                this.$store.commit('SET_BUCKETKEY', bucketKey);
            } else {
                tempBucketKey = this.$store.state.storage.bucketKey;
            }
            // 对应左侧列表高亮
            this.currentBucket = tempBucketKey;
            this.getPageObjectsFun();
            // 30s自动刷新界面
            setTimeout(() => {
                this.setTimeoutState(bucketKey, () => {
                    this.refreshFileList(this.$store.state.storage.bucketKey);
                });
            }, 1000);
        },
        getPageObjectsFun() {
            let data = {
                pageNumber: this.currentPage,
                pageSize: 14,
                viewType: '3d', // 过滤3d视图的模型，只有三维模型才能进行LOD转换
            };
            getPageObjects(this.currentBucket, data)
                .then((res) => {
                    this.isTableLoading = false;
                    this.objectNumber = res.data.length;
                    this.totalCount = res.totalPages * 10;
                    if (res && res.data.length !== 0) {
                        this.getAllJobStatusFun(res.data);
                    } else {
                        this.modelsData = [];
                    }
                })
                .catch(() => {
                    this.isTableLoading = false;
                });
        },
        getAllJobStatusFun(temp) {
            getAllJobStatus(this.currentBucket, temp).then((res) => {
                // 修改文件状态
                res.data.forEach((item) => {
                    const tempNameArr = item.seed.split('/');
                    const fileName = tempNameArr[tempNameArr.length - 1];
                    if (analysisFileType(fileName) === 'tifzip') {
                        this.modelsData.push(item);
                    } else {
                        temp.forEach((modelEle, index) => {
                            if (modelEle.fileName === fileName) {
                                if (item.state !== 'complete') {
                                    temp.splice(index, 1);
                                }
                            }
                        });
                    }
                });

                // 查询job的状态
                temp.forEach((item) => {
                    this.getJobStatusForLodFun(item);
                });
                this.modelsData = temp;
            });
        },
        getJobStatusForLodFun(item) {
            let jobType =
                analysisFileType(item.fileName) === 'gim'
                    ? 'gim-lod'
                    : analysisFileType(item.fileName) === 'tifzip'
                    ? 'tifzip-lod'
                    : 'obmx-lod';
            let data = {
                urn: item.fileUrn,
                jobType: jobType,
            };
            getJobStatusForLod(data)
                .then((res) => {
                    item.modelStatus = JOB_STATUS[`job_status_${res.data.state}`];
                    item.translateTime = formatTime(res.data.create_at);
                    item.modelStatus === '完成转换'
                        ? (item.consumingTime.lod = formatConsumingTime(res.data.create_at, res.data.update_at))
                        : (item.consumingTime.lod = '-');
                })
                .catch((err) => {
                    if (
                        err.status === '404' &&
                        err.responseJSON.code &&
                        err.responseJSON.message.includes('NoSuchJob')
                    ) {
                        item.consumingTime.lod = '-';
                        item.translateTime.lod = '-';
                    }
                });
        },
        /*
         * 单条/批量转换刷新转换数据
         * more=true ----批量勾选转换；
         * more=false ----单条转换
         * */
        refreshFileListForLodBatch(bucketKey, more) {
            if (more) {
                this.multipleSelection = sessionStorage.getItem('activeLod')
                    ? JSON.parse(sessionStorage.getItem('activeLod'))
                    : this.multipleSelection;
                // 查询job的状态
                this.multipleSelection.forEach((item) => this.getJobStatus(item.fileUrn));
            } else {
                const lodFile = sessionStorage.getItem('activeLodRow')
                    ? JSON.parse(sessionStorage.getItem('activeLodRow'))
                    : this.currentRow;
                this.getJobStatus(lodFile.fileUrn);
            }
            // 30s自动刷新界面
            setTimeout(() => {
                this.setTimeoutState(bucketKey, () => {
                    this.refreshFileListForLodBatch(this.$store.state.storage.bucketKey, more);
                });
            }, 1000);
        },

        // 轮询
        setTimeoutState(bucketKey, callback) {
            if (this.modelsData.length > 0 && bucketKey === this.$store.state.storage.bucketKey) {
                this.modelsData.forEach((e) => {
                    if (e.modelStatus === '排队等候') {
                        this.modelStatusArr.push(e.modelStatus);
                    } else if (e.modelStatus === '正在转换') {
                        this.modelStatusArr.push(e.modelStatus);
                    }
                });
                if (this.modelStatusArr.length > 0) {
                    this.modelStatusArr.forEach((e) => {
                        if (e === '正在转换' || e === '排队等候') {
                            this.modelChangeArr.push(e);
                        }
                    });
                    if (this.modelChangeArr.length > 0) {
                        this.modelChangeArr = [];
                    }
                    setTimeout(() => {
                        callback();
                    }, 30000);
                    this.modelStatusArr = [];
                }
            }
        },

        // 查询转化状态
        getJobStatus(urn) {
            let jobType =
                analysisFileType(urn) === 'gim'
                    ? 'gim-lod'
                    : analysisFileType(urn) === 'tifzip'
                    ? 'tifzip-lod'
                    : 'obmx-lod';
            const data = {
                urn,
                jobType: jobType,
            };
            getJobStatusForLod(data)
                .then((res) => {
                    const index = this.modelsData.findIndex((file) => file.fileUrn === urn);
                    this.modelsData[index].modelStatus = JOB_STATUS[`job_status_${res.data.state}`];
                    this.modelsData[index].translateTime = formatTime(res.data.create_at);
                    this.modelsData[index].consumingTime =
                        this.modelsData[index].modelStatus === '完成转换'
                            ? formatConsumingTime(res.data.create_at, res.data.update_at)
                            : '-';
                })
                .catch((rej) => {
                    console.log('LodError', rej);
                });
        },

        /*
         * 模型查看-临时处理
         *
         * */
        async viewmodel(row) {
            let _self = this;
            if (row.modelStatus === '完成转换') {
                let res = await getObjectViewToken();
                _self.tokenData = res.data.newToken;
                const build = new OBV.Api.ObvBuilder();
                const applicationOptions = {
                    getAccessToken(cb) {
                        cb(_self.tokenData, 60000);
                    },
                    serviceConfig: {
                        origin: `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}`,
                        apiContextPath: RuntimeUtils.instance.servicePath,
                    },
                    viewer3dConfig: {},
                };
                const application = await build.buildApplication(applicationOptions);
                const tempJobType = await getJobType(analysisFileType(row.fileName), 'lod');
                let obvDocument = null;
                try {
                    obvDocument = await build.loadDocument(application, row.fileUrn, tempJobType);
                    // TODO 拥有视图与没有视图进行不同的处理
                    if (obvDocument.getRootItem().children && obvDocument.getRootItem().children.length > 0) {
                        _self.allJobType = {
                            obv: null,
                            lod: tempJobType,
                        };
                        const _modelViews = _self.$refs.modelViews; // 取modelViews实例
                        _modelViews.isDisabled.obv = true;
                        _modelViews.isDisabled.lod = false;
                        _modelViews.typeName = 'lod';
                        if (_self.$route.query.version) {
                            _modelViews.OpenV4(row.fileUrn, row.fileName, 'v4');
                        } else {
                            _modelViews.OpenV5(row.fileUrn, row.fileName);
                        }
                    } else {
                        _self.oldViewModel(row);
                    }
                } catch (err) {
                    if (err.errorMessage && err.errorMessage.errorCode === 12) {
                        _self.oldViewModel(row);
                    } else {
                        this.$message('文件异常！');
                    }
                }
            } else {
                this.$message('文件未转换完成');
            }
        },

        oldViewModel(row) {
            const loadType =
                analysisFileType(row.fileName) === 'gim'
                    ? 'gim-lod'
                    : analysisFileType(row.fileName) === 'tifzip'
                    ? 'tifzip-lod'
                    : 'obmx-lod';
            const tempGuid = null;
            const jobType = base64UrlEncode(loadType);
            const tempName = base64UrlEncode(row.fileName);
            const tempCurrentUrn = base64UrlEncode(row.fileUrn);
            const tempURL = `${window.location.origin}/devcenter/console/view?name=${tempName}&urn=${tempCurrentUrn}&guid=${tempGuid}&jobType=${jobType}`;
            window.open(tempURL, '_blank');
        },

        async Open(urn, fileName) {
            let _self = this;
            let res = await getObjectViewToken();
            _self.tokenData = res.data.newToken;
            await _self.initModelViews(res.data.newToken, `${urn}`);
            await _self.getModelView(_self.modelViewsData[0].children[0], fileName, urn);
        },

        async initModelViews(token, urn) {
            const _self = this;
            const build = new OBV.Api.ObvBuilder();
            const applicationOptions = {
                getAccessToken(cb) {
                    cb(token, 60000);
                },
                serviceConfig: {
                    origin: `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}`,
                    apiContextPath: RuntimeUtils.instance.servicePath,
                },
                viewer3dConfig: {},
            };
            const application = await build.buildApplication(applicationOptions);
            const loadType =
                analysisFileType(urn) === 'gim'
                    ? 'gim-lod'
                    : analysisFileType(urn) === 'tifzip'
                    ? 'tifzip-lod'
                    : 'obmx-lod';
            const obvDocument = await build.loadDocument(application, urn, loadType);

            const folderItemList = obvDocument.getViewableItems(obvDocument.getRootItem());
            folderItemList.forEach((element, index) => {
                _self.modelViewsData.push({
                    name: element.name,
                });
                if (index === 0) {
                    _self.activeView = element.name;
                }
                if (element.children.length !== 0) {
                    _self.modelViewsData[index].children = [];
                    element.children.forEach((elementCard) => {
                        _self.modelViewsData[index].children.push({
                            cardName: elementCard.name,
                            guid: elementCard.guid,
                            imgUrl: `${process.env.STATIC}dataMock/fileMng/default-image.png`,
                        });
                    });
                }
            });
            _self.getItemThumbnailUrl(obvDocument, folderItemList);
        },

        getItemThumbnailUrl(obvDocument, list) {
            const listItemArr = [];
            const _self = this;
            list.forEach((listitem, listIndex) => {
                if (listitem.children.length !== 0) {
                    listitem.children.forEach((cardItem, cardIndex) => {
                        const thumbnailUrn = obvDocument.hasThumbnail(cardItem, true);
                        if (thumbnailUrn) {
                            obvDocument.getThumbnailUrl(cardItem).then((res) => {
                                if (res) {
                                    _self.modelViewsData[listIndex].children[cardIndex].imgUrl = res;
                                    if (listIndex === 0) {
                                        _self.$forceUpdate();
                                    }
                                }
                            });
                        }
                    });
                }
            });
        },

        // getModelView(viewModel, fileName, currentUrn) {
        //     const tempName = base64UrlEncode(`${fileName}-${viewModel.cardName}`);
        //     const tempCurrentUrn = base64UrlEncode(currentUrn);
        //     // const tempGuid = base64UrlEncode(viewModel.guid);
        //     const tempGuid = null;
        //     const loadType =
        //         analysisFileType(currentUrn) === 'gim'
        //             ? 'gim-lod'
        //             : analysisFileType(currentUrn) === 'obvzip'
        //             ? 'obvzip-obv'
        //             : 'obmx-lod';
        //     const jobType = base64UrlEncode(loadType);
        //     const tempURL = `${window.location.origin}/devcenter/console/view?name=${tempName}&urn=${tempCurrentUrn}&guid=${tempGuid}&jobType=${jobType}`;
        //     window.open(tempURL, '_blank');
        // },

        getModelView(currentUrn, fileName) {
            const tempName = base64UrlEncode(fileName);

            const tempCurrentUrn = base64UrlEncode(currentUrn);
            const tempGuid = null;
            const loadType =
                analysisFileType(currentUrn) === 'gim'
                    ? 'gim-lod'
                    : analysisFileType(currentUrn) === 'tifzip'
                    ? 'tifzip-lod'
                    : 'obmx-lod';
            const jobType = base64UrlEncode(loadType);
            const tempURL = `${window.location.origin}/devcenter/console/view?name=${tempName}&urn=${tempCurrentUrn}&guid=${tempGuid}&jobType=${jobType}`;
            window.open(tempURL, '_blank');
        },

        // 获取所有的bucket并初始化项目
        getAppAllInit() {
            getAllBucket()
                .then((res) => {
                    const ownerName = getUserName();
                    this.currentBucket = ownerName;
                    if (res.data.buckets.length !== 0) {
                        res.data.buckets.forEach((ele, index) => {
                            if (ele.bucket_key !== 'translation_result_v2') {
                                this.bucketItems[0].children.push({
                                    name: ele.bucket_key,
                                    id: index,
                                });
                                // 给子组件
                                this.bucketOptions.push({
                                    label: ele.bucket_key,
                                    value: ele.bucket_key,
                                });
                            }
                        });
                    }
                    // 查询默认bucket下数据情况
                    this.refreshFileList(this.currentBucket);
                })
                .catch(() => {
                    this.isTableLoading = false;
                });
        },
    },
    beforeDestroy() {
        sessionStorage.removeItem('activeLod');
        sessionStorage.removeItem('activeLodRow');
    },
    mounted() {
        this.isTableLoading = true;
        getAppInfo()
            .then((appRes) => {
                // 判断是否是第一次使用app
                if (appRes.items.length !== 0) {
                    // 保存用户名
                    setUserName(appRes.items[0].owner);
                    // 储存对应的bucket
                    this.$store.commit('SET_BUCKETKEY', appRes.items[0].owner);
                    this.getAppAllInit();
                } else {
                    this.$router.push('/devcenter/console/myapp');
                }
            })
            .catch(() => {
                this.isTableLoading = false;
            });

        // 初始化obvjs
        DynamicLoad.loadJs(RuntimeUtils.instance.obv5JsPath).then((res) => {
            if (res) {
                this.OBVJSStatus = true;
            }
        });
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.lodLoad >>>
.el-table-column--selection .cell
  dom_center()

.el-table td, .el-table th.is-leaf
  border 0px

.el-table--border th, .el-table__fixed-right-patch
  border 0px

.el-table
  user-select text
  background-color transparent

.el-table .odd-row
  background #FFFFFF

.el-table .even-row
  background #F8F8F8

.el-col
  display flex
  align-items center

.el-input__inner
  border-radius 20px

.lodLoad >>>
.el-table__row
  .icon
    font-size 16px
    color $font-title
    opacity 0.6
    padding 0px 10px

    &:hover
      color #0C78E2
      opacity 1
      cursor pointer

  .icon.delete
    &:hover
      color rgb(255, 73, 41)
      opacity 1

  .el-progress
    padding 0px 10px

.lodLoad
  background-color $background-darkwhite
  width 88%

  .page-content
    height 100%
    width 100%

    .page-content-head
      height 7%
      min-height 50px

      .el-row
        height 100%

        .el-col
          height 100%

          .upload-btn
            width 100px
            height 40px
            margin-left 4%
            border-radius 20px
            border 0px
            outline none
            background-color rgb(12, 193, 226)

            i
              font-size 16px

          .delete-btn
            width 100px
            height 40px
            margin-left 10px
            border-radius 20px
            border 0px
            outline none
            background-color rgb(255, 73, 41)

            i
              font-size 16px

          .refresh-btn
            width 100px
            height 40px
            margin-left 10px
            border-radius 20px
            border 0px
            outline none
            background-color #0C78E2

            i
              font-size 16px

  .page-content-search
    height 9%
    align-items center
    justify-content space-evenly
    display flex
    color #999999

    .keyword-search
      width 156px

    .search-btn
      color $font-white
      width 115px
      height 40px
      margin-left 19px
      border-radius 20px
      border 0px
      background-color #0C78E2

  .page-table-content
    width 100%
    height 93%
    display flex

    .bucket-list >>>
    .el-collapse
      margin-top 0px

    .el-collapse-item__header
      height 50px
      border-bottom 2px
      border-style solid
      border-color $background-darkwhite

    .el-collapse-item
      background-color $background-white

    .el-collapse-item__content
      padding-bottom 0px
      border-bottom 2px
      border-style solid
      border-color $background-darkwhite

    .bucket-list
      width 9%
      min-width 145px
      margin-left 10px
      margin-right 10px
      overflow auto

      .listItem
        border 0px
        height 50px
        font-size 14px
        dom_center()
        box-sizing border-box

        &:hover
          background-color #F5F5F5
          color $font-activeBlue

        &.activeItem
          background-color #F5F5F5
          color $font-activeBlue

    .page-list
      width 90%

    .page-list >>>
    .el-table
      width 100% !important
      height 93% !important

    .paging
      width 95%
      margin-top 10px
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/lodLoad/lodLoad.vue